{
    const carousel = document.querySelector('.carousel-thumbnails');
    const scroller = document.querySelector('.thumbnails__scroller');
    const thumbnails = document.querySelectorAll('.thumbnails__image');

    if (carousel === null || scroller === null || thumbnails === null) {
        console.log('Carousel not found');
    }else{
        scroller.addEventListener('click', e => {
            const target = e.target;

            if (target.matches('.thumbnails__image')) {
                const index = [...thumbnails].indexOf(target);
                carousel.goToSlide(index);
            }
        });

        carousel.addEventListener('sl-slide-change', e => {
            const slideIndex = e.detail.index;

            [...thumbnails].forEach((thumb, i) => {
                thumb.classList.toggle('active', i === slideIndex);
                if (i === slideIndex) {
                    thumb.scrollIntoView({
                        block: 'nearest'
                    });
                }
            });
        });
    }


}

document.addEventListener('DOMContentLoaded', function () {
    Livewire.on('updateCarousel', function (data) {
        data = data[0].value
        if (!data){
            return;
        }

        const mapping = [
            { keyword: "Generosity", match: "Chá - Generosity" },
            { keyword: "Gratitude", match: "Chá - Gratitude" },
            { keyword: "Relationships", match: "Chá - Meaningful Relationships" },
            { keyword: "Purpose", match: "Chá - Purpose" },
            { keyword: "greenyellow", match: "green" }
        ];

        const mappedData = mapping.find(({ keyword }) => data.toLowerCase().includes(keyword.toLowerCase()))?.match || data;


        const images = document.querySelectorAll('[data-image-name]');
        console.log(data)
        Array.from(images).some(image => {
            if (image.dataset.imageName.toLowerCase().includes(mappedData.toLowerCase())
                || mappedData.toLowerCase().includes(image.dataset.imageName.toLowerCase())) {
                image.click();
                return true;
            }
            return false;
        });
    });
});
